var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useCallback, useEffect, useMemo, useRef } from 'react';
import { createPortal } from 'react-dom';
import Button from '@r1-frontend/ui-react/components/buttons/button';
import { Close } from '@r1-frontend/ui-react/components/svg/main';
import { useKeyPress } from '@r1-frontend/shared/hooks/useKeyPress';
import { useRootElement } from '@r1-frontend/shared/hooks/useRootElement';
import { useScrollLock } from '@r1-frontend/shared/hooks/useScrollLock';
import * as ST from './styled';
export var Overlay = function (_a) {
    var isOpen = _a.isOpen, children = _a.children, _b = _a.align, align = _b === void 0 ? 'center' : _b, _c = _a.justify, justify = _c === void 0 ? 'center' : _c, fullWidth = _a.fullWidth, fullHeight = _a.fullHeight, onClose = _a.onClose, _d = _a.$zIndex, $zIndex = _d === void 0 ? 1000 : _d, _e = _a.$opacity, $opacity = _e === void 0 ? 0.5 : _e;
    var overlayRef = useRef(null);
    var overlayRoot = useRootElement({ id: 'overlay-portal' });
    var _f = useScrollLock(), lockScroll = _f.lockScroll, unlockScroll = _f.unlockScroll;
    /* Обеспечивает разблокировку прокрутки при закрытии попапа, при размонтировании компонента. */
    useEffect(function () {
        return function () { return unlockScroll(); };
    }, []);
    useEffect(function () {
        isOpen ? lockScroll() : unlockScroll();
    }, [isOpen]);
    var closeOverlayOnClickOutside = useCallback(function (event) { return event.target === overlayRef.current && onClose(); }, [onClose]);
    useKeyPress('Escape', onClose);
    var overlay = useMemo(function () { return isOpen
        ? (<ST.Overlay data-test={'overlay'} ref={overlayRef} onClick={closeOverlayOnClickOutside} align={align} justify={justify} $zIndex={$zIndex} $opacity={$opacity}>
                    <ST.OverlayContent data-test={'overlay-content'} fullWidth={fullWidth} fullHeight={fullHeight}>
                        {children}
                    </ST.OverlayContent>
                </ST.Overlay>)
        : null; }, [isOpen, children, closeOverlayOnClickOutside, align, fullWidth, justify, fullHeight]);
    return overlayRoot ? createPortal(overlay, overlayRoot) : null;
};
export var OverlayWithCloseButton = function (_a) {
    var closeButton = _a.closeButton, children = _a.children, onClose = _a.onClose, props = __rest(_a, ["closeButton", "children", "onClose"]);
    return (<Overlay {...props} onClose={onClose}>
            {closeButton || (<Button bType={'secondary'} size={'small'} rounded Icon={<Close />} onClick={onClose} style={{
                position: 'absolute',
                top: '40px',
                right: '40px',
            }}/>)}
            {children}
        </Overlay>);
};
